import { render, staticRenderFns } from "./ModuleCreateEdit.vue?vue&type=template&id=2a5addcc&"
import script from "./ModuleCreateEdit.vue?vue&type=script&lang=js&"
export * from "./ModuleCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports